<template>
  <div v-if="loaded">
    <div class="hero">
      <img src="../assets/images/top-lines.svg" alt="lines" class="top-lines">
      <img src="../assets/images/bottom-lines.svg" alt="lines" class="bottom-lines">
      <div class="hero__content">
        <div class="content-left">
          <h1 class="hero__title"
              :class="[currentLanguage == 'AR' ? 'rtlText': '']">
            {{ $t('hero.title') }}
            <span class="subtitle">{{ $t('hero.subtitle') }}</span>
          </h1>
          <button class="hero__cta"
                  :class="[currentLanguage == 'AR' ? 'rtlText': '']"
                  @click="openSignInModal"
                  v-if="!isLoggedIn">
            {{ $t("signin") }}
          </button>
        </div>
        <div class="content-right">
          <img src="../assets/images/hero-img.png" alt="welcome our page" class="hero-image">
          <img src="../assets/images/small-hero-img-1.png" alt="welcome our page" class="small-hero-img-1">
          <img src="../assets/images/small-hero-img-2.png" alt="welcome our page" class="small-hero-img-2">
          <img src="../assets/images/small-hero-img-3.png" alt="welcome our page" class="small-hero-img-3">
          <img src="../assets/images/yellow-circle.png" alt="yellow-circle" class="yellow-circle">
        </div>
      </div>
    </div>
    <div class="info-boxes">
      <div class="section__inner">
        <ul>
          <li>
            <div class="list-image">
              <img src="../assets/images/icons/unlimited-games.svg" alt="unlimited-games">
            </div>
            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">
              {{ $t("hero.banner.title1") }}
            </h2>
          </li>
          <li>
            <div class="list-image">
              <img src="../assets/images/icons/cross-platform.svg" alt="cross-platform">
            </div>
            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">
              {{ $t("hero.banner.title2") }}
            </h2>
          </li>
          <li>
            <div class="list-image">
              <img src="../assets/images/icons/no-plugin.svg" alt="no-plugin">
            </div>
            <h2>{{ $t("hero.banner.title3") }}</h2>
          </li>
          <li>
            <div class="list-image">
              <img src="../assets/images/icons/supported-browser.svg" alt="supported-browser">
            </div>
            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">
              {{ $t("hero.banner.title4") }}
            </h2>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="products"
      v-for="category in allCategories"
      :key="category.order"
    >
      <section class="section--products__home">
        <BaseCarousel
          :products="category.products"
          :title="category.fullname"
          :categoryId="category.name"
          :layout="category.design"
          :showButtonCarouselE="category.fullname !== 'Favourites'"
          :showButtonCarouselU="category.fullname !== 'Premium Games'"
        />
      </section>
    </div>

    <section class="section--categories__home">
      <div class="section__head">
        <h2 class="box-title">{{ $t("home.categories.title") }}</h2>
      </div>
      <div class="categories">
        <div class="categories__body">
          <ul class="categories__list">
            <li v-for="category in visibleOurCategories" :key="category.id" class="categories__card">
              <router-link :to="{
                name: 'ProductCategory',
                params: {
                  type: ($route.params.id || '1'),
                  title: category.item,
                  id: category.id
                },
              }">
                <div class="categories_icon_item">
                  <img
                    :src="category.img"
                    :alt="category.item"
                  />
                </div>
                <div class="categories_link_item">
                  <span>{{ category.item }}</span>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <cookie-law theme="portal" :buttonText="$t('cookie.btn')">
      <template #message>
        <div :class="[currentLanguage == 'AR' ? 'rtlText': '']">
          {{ $t("cookie.message") }}
          <router-link to="cookies-policy" :class="[currentLanguage == 'AR' ? 'rtlText': '']">
            {{ $t("cookie.link") }}
          </router-link>
        </div>
      </template>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from '../components/CookieLaw.vue';
import { mapGetters } from 'vuex';
import axios from 'axios';
import { helpers } from '../helper/portal_config';
import EventBus from '../helper/event_bus';

import BaseCarousel from '../components/BaseCarousel';

// api to get products
const apiPrTypeMethod = 'getProductListByType';

export default {
  name: 'Home',
  title: helpers.portal_name,
  data() {
    return {
      helpers: '',
      categories: [],
      allCategories: [],
      hasBannerFlag: null,
      currentLanguage: "",
      currentCountry: "",
      options: { quality: { default: '1080p' } },
      loaded: false,
    };
  },
  components: {
    BaseCarousel,
    CookieLaw
  },
  methods: {
    checkIsLogged() {
      // if you are not login than showed modal
      if (!this.isLoggedIn) {
        EventBus.$emit('SHOW_SIGNIN_MODAL');
      }
    },
    setProducts(types) {
      const keys = Object.keys(types);
      keys.forEach((element, index) => {
        types[element].fullname = element;
        if (element === 'Favourites') {
          types[element].design = 'E';
        }
        this.allCategories.push(types[element]);
      });
      // filtered only homepage
      const categoriesFiltered = this.allCategories.filter((item) => item.homepage > 0);
      // sorting homepage categories
      this.sortProducts(categoriesFiltered);
    },
    sortProducts(filteredProducts) {
      filteredProducts.sort((a, b) => a.homepage - b.homepage);
      filteredProducts = this.slicesProducts(filteredProducts);
      this.allCategories = filteredProducts;
    },
    slicesProducts(products) {
      return products.map((item) => {
        item.products = item.products.slice(0, item.max_products);
        return item;
      });
    },
    sortCategories(categoriesLocal) {
      categoriesLocal.sort((a, b) => a.order - b.order);
      this.categories = categoriesLocal;
    },
    hasBanner() {
      let banner = document.querySelector('.page-header__menu li.is-active a');
      let type = banner.getAttribute('href').substr(banner.getAttribute('href').length-1, banner.getAttribute('href').length);
      console.log( type);
      return helpers.menu.some(function(item) {
        return (item.type == type && item.isActive == true && item.banner == 1);
      });
    },
    setCurrentCountry() {
      const { host } = window.location;
      this.currentCountry = host.split('.')[0].slice(0,2).toUpperCase();
    },
    setCurrentLanguage() {
      var lang = "";
      const { host } = window.location;
      var country = host.split('.')[0].slice(0,2).toUpperCase();
      if (helpers.countryDefaultLanguage.hasOwnProperty(country)) {
        lang = helpers.countryDefaultLanguage[country].toUpperCase();
      } else {
        lang = country.toUpperCase();
      }
      this.currentLanguage = lang;
    },
    async fetchCategories() {
      // check user was logged and send access_code as a parameter.
      this.loaded = false;
      let apiUrl = null;
      if (this.isLoggedIn) {
        apiUrl = `${helpers.API_BASE_URL}/store/${apiPrTypeMethod}?portal_name=${helpers.portal_name
        }&country=${this.currentCountry}&language=${this.currentLanguage}&product_type=${this.$route.params.id || helpers.portal_type
        }&access_code=${this.accessCode}`;
      } else {
        apiUrl = `${helpers.API_BASE_URL}/store/${apiPrTypeMethod}?portal_name=${helpers.portal_name
        }&country=${this.currentCountry}&language=${this.currentLanguage}&product_type=${this.$route.params.id || helpers.portal_type
        }`;
      }

      await axios
        .get(
          apiUrl
        )
        .then((response) => {
          console.log('categories raw:', response.data.categories);
          if (response.data.treatment === 1) {
            const { categories } = response.data;
            const types = categories;
            this.setProducts(types);

            // upload categories
            const categoriesKeys = Object.keys(categories);
            const categoriesLocal = [];
            categoriesKeys.forEach((element, index) => {
              const obj = {
                id: types[element].name,
                item: element,
                order: types[element].order,
                icon_identifier: types[element].icon_identifier
              };
              categoriesLocal.push(obj);
            });
            this.sortCategories(categoriesLocal);
            this.loaded=true;
          }
        });
    },
    openSignInModal() {
      EventBus.$emit('SHOW_SIGNIN_MODAL')
    },
  },
  computed: {
    ...mapGetters({
      accessCode: 'globals/accessCode',
      isLoggedIn: 'globals/isLoggedIn',
    }),
    visibleOurCategories() {
      const categoriesFiltered = (this.categories || []).filter(
        (c) => c && c.order != null
      )
      categoriesFiltered.forEach(categ => {
        try {
          categ.img = require(`@/assets/images/icons/${categ.icon_identifier}.png`)
        } catch (e) {
          console.warn(`Icon not found for category: ${categ.item}`)
          categ.img = require('@/assets/images/icons/logic.png')
        }
      })
      return categoriesFiltered
    }
  },
  watch: {
    $route(to, from) {
      this.allCategories = [];
      this.categories = [];
      this.fetchCategories();
    },
  },
  created() {
    this.helpers = helpers;

    this.setCurrentLanguage();
    this.setCurrentCountry();

    this.fetchCategories();
  },
  mounted() {
    this.hasBannerFlag = this.hasBanner();
  },
};
</script>

<style>
.Cookie--portal {
  background: #000;
  padding: 8px 25px;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.1);
}

.Cookie--portal {
  color: #fff;
  font-size: 14px;
}

.Cookie--portal a {
  color: #fff;
  font-size: 14px;
  text-decoration: underline;
}

.Cookie--portal a:hover {
  color: #F3D200;
}

.Cookie--portal .Cookie__button {
  background: #222;
  color: #F3D200;
  border-radius: 5px;
  padding: 10px 35px;
}

.Cookie--portal .Cookie__button:hover {
  background: #F3D200;
  color: #222;
}

@media (max-width: 800px) {
  .Cookie--portal .Cookie__button {
    margin-bottom: 0;
  }

  .Cookie--portal .Cookie__content {
    margin: 0;
  }

  .Cookie--portal .Cookie__button {
    font-size: 12px;
  }

  .Cookie--portal .Cookie__buttons {
    margin-top: 5px;
  }
}
</style>
